import React from 'react';
import PropTypes from 'prop-types';
import { Column, Row } from '@pella/sash-framework';
import { Image } from '../../../';

const ImagePanel = ({ data }) => {
	return (
		<div className='imagePanel'>
			<Row
				align='center'
				verticalGutters
			>
				{data?.image?.[0] && (
					<Column
						xs={12}
						sm={4}
					>
						<Image
							data={data.image[0]}
							className='w-full'
						/>
					</Column>
				)}

				<Column
					xs={12}
					sm={8}
				>
					{data?.heading && <div dangerouslySetInnerHTML={{ __html: data.heading }} />}
					{data?.description && <div dangerouslySetInnerHTML={{ __html: data.description }} />}
				</Column>
			</Row>
		</div>
	);
};

ImagePanel.propTypes = {
	data: PropTypes.object.isRequired,
};

export default ImagePanel;
